import aiMascot from '@/assets/ai-mascot-dark.svg'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

/**
 * Приглашения «напишите что хотите изменить» здесь нет намеренно: свободного
 * чата у панели нет (ручки «переделай курс» не существует), и поле вне режима
 * генерации заблокировано. Звать печатать в погашенное поле — та же фальшивая
 * affordance, что и кнопка отмены без ручки отмены.
 */
export const MascotEmptyState = () => {
  const m = useMessages(messages)
  return (
    <div className="flex flex-1 flex-col items-center justify-center p-4">
      <img src={aiMascot} alt="" className="mb-3 h-32 w-32 object-contain" />
      <p className="px-8 text-center text-sm text-muted-foreground">{m.emptyState}</p>
    </div>
  )
}

// `SelectBlockHint` убран (ревью Task 3, Important 1): область правки
// достижима без выделенного блока (сценарий «выбран урок, блок нет» —
// штатный после клика по уроку в таймлайне), `EditBlockSettings` (Task 2)
// сама объясняет текстом все пустые случаи — отдельная карточка-заглушка
// поверх неё была фальшивым дублем.
